import _findIndex from 'lodash/findIndex';

/**
 * @desc  HappeningService class.
 * @ngInject
 */
export default class HappeningService {
  /**
   * Constructor of the class.
   *
   * @param {$rootScope} $rootScope
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   */
  constructor(
    $rootScope, $q, $log, $http
  ) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;

    this.happenings = [];

    this.$rootScope.$on('scr.select', () => {
      this.happenings.splice(0, this.happenings.length);
    });
  }

  add(options) {
    const copyHappening = {};
    angular.copy(options.data, copyHappening);
    return this.$http({
      method: 'POST',
      url: `/SCR/employee/${this.$rootScope.me.employeeId}/happening`,
      data: {happening: options.data}
    }).then(result => {
      copyHappening.id = String(result.data.id);
      if (options.addToLocal) {
        copyHappening.students = copyHappening.studentObjects;
        copyHappening.employee = this.$rootScope.me;
        copyHappening.employee.id = this.$rootScope.me.employeeId;
        copyHappening.employee.fullName = this.$rootScope.me.name;
        this.happenings.unshift(copyHappening);
      }

      return true;
    }, err => this.$q.reject(err));
  }

  getAll(fromServer = false) {
    if (this.happenings.length > 0 && !fromServer) {
      return this.$q.resolve(this.happenings);
    }

    return this.$http({
      method: 'GET',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/happenings`
    }).then(result => {
      this.happenings = result.data.happenings;
      return this.happenings;
    }, err => this.$q.reject(err));
  }

  get(id) {
    return this.$http({
      method: 'GET',
      url: `/SCR/employee/${this.$rootScope.me.employeeId}/happening/${id}`
    }).then(
      result => result.data.happening[0],
      err => this.$q.reject(err)
    );
  }

  edit(options) {
    const copyHappening = {};
    angular.copy(options.data, copyHappening);
    return this.$http({
      method: 'PUT',
      url: `/SCR/employee/${this.$rootScope.me.employeeId}/happening/${options.data.id}`,
      data: {happening: options.data}
    }).then(() => {
      const id = _findIndex(this.happenings, ['id', copyHappening.id]);
      copyHappening.students = copyHappening.studentObjects;
      this.happenings[id] = copyHappening;
      return true;
    }, err => this.$q.reject(err));
  }

  delete(options) {
    return this.$http({
      method: 'DELETE',
      url: `/SCR/employee/${this.$rootScope.me.employeeId}/happening/${options.data}`
    }).then(result => {
      const idToRemove = _findIndex(this.happenings, ['id', options.data]);
      this.happenings.splice(idToRemove, 1);
      return result;
    }, err => this.$q.reject(err));
  }

  getStudents(id, params = {}) {
    return this.$http({
      method: 'GET',
      url: `/SCR/happenings/${id}/unassignedStudents`,
      params: {limit: params.limit, offset: params.offset, condition: params.query}
    }).then(result => result, err => this.$q.reject(err));
  }
}
